import { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { MODAL_SIZES } from 'shared-modules/constants';
import { RUN_NOW_ERROR_MESSAGES } from 'shared-modules/constants/errorMesages';
import { formatPrice } from 'shared-modules/services';
import styles from '../../RunAutoTradeComponents/runAllFail.module.scss';
import { Button, Modal } from '../../../../../components';

export const MarginErrorModal = memo(({ isOpen, closeModal, currentOrderableMargin, marginRequired, shortfall }) => {
  const formattedCurrentOrderableMargin = formatPrice({ value: currentOrderableMargin, withoutPlus: true })[0];
  const formattedMarginRequired = formatPrice({ value: marginRequired, withoutPlus: true })[0];
  const formattedShortFall = formatPrice({ value: shortfall, withoutPlus: true })[0];
  // TODO constantsとして抽出
  return (
    <Modal isOpen={isOpen} closeModal={closeModal} size={MODAL_SIZES.WIDTH_400} withoutHeader isErrorNotification>
      <div className={styles.errorIconContainer}>
        <i className={classNames('material-icons-outlined', styles.errorIcon)}>error_outline</i>
      </div>
      <div className={styles.errorMessageTitle}>{RUN_NOW_ERROR_MESSAGES.allErrorTitle}</div>

      <div className={styles.marginErrorTextContainer}>
        <div className={styles.marginErrorText}>発注証拠金が不足しています。</div>
        <div className={styles.marginErrorText}>追加のご入金、または、発注中の新規注文を停止してください。</div>
        <div className={styles.marginErrorText}>
          {`現在の発注可能額：${formattedCurrentOrderableMargin}円
          発注証拠金：${formattedMarginRequired}円
          不足額：${formattedShortFall}円`}
        </div>
      </div>

      <div className={styles.buttonContainer}>
        <Button width={400} className={styles.closeErrorModalButton} secondary onClick={closeModal}>
          とじる
        </Button>
      </div>
    </Modal>
  );
});

MarginErrorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  currentOrderableMargin: PropTypes.number.isRequired,
  marginRequired: PropTypes.number.isRequired,
  shortfall: PropTypes.number.isRequired,
};
